import {useCallback, useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router';

import {BasicDistributorT} from '@/lib/types/user.types';

import {useAuth} from '@/providers/components/authProvider';

import {SearchAndSelectComponent} from '@/components';

import CreateDistributorOrderForm from './components/createDistributorOrderForm';
import {CreateDistributorOrderProvider} from './providers/createDistributorOrderProvider';

function CreateDistributorOrderPage() {
  const navigate = useNavigate();
  const {distributorId} = useParams();
  const {
    userAccounts: {distributors},
  } = useAuth();

  const [searchModalVisible, setSearchModalVisible] = useState(false);
  const selectedDistributor = distributors?.find(d => d.distributor_id === Number(distributorId));

  useEffect(() => {
    if (!distributorId) {
      if (distributors && distributors.length === 1) {
        // Redirect to the same page with retailer ID if there's only one
        navigate(`/distributor/orders/${distributors[0].distributor_id}/new`);
      } else {
        setSearchModalVisible(true);
      }
    }
  }, [distributors, navigate, distributorId]);

  const handleDistributorSelect = useCallback(
    (distributor: BasicDistributorT) => {
      navigate(`/distributor/orders/${distributor.distributor_id}/new`);
      setSearchModalVisible(false);
    },
    [navigate]
  );

  // If no retailerId and no retailers, show error
  if (!selectedDistributor && (!distributors || distributors.length === 0)) {
    return <div>No distributors found</div>;
  }

  return (
    <>
      {selectedDistributor ? (
        <CreateDistributorOrderProvider distributorId={selectedDistributor.distributor_id}>
          <CreateDistributorOrderForm />
        </CreateDistributorOrderProvider>
      ) : (
        <SearchAndSelectComponent<BasicDistributorT>
          title="Select a Distributor"
          isVisible={searchModalVisible}
          onClose={() => navigate('/distributor/orders')}
          overrideClose={true}
          onSelect={handleDistributorSelect}
          onSearch={() => null}
          results={distributors || []}
          mapStructure={{
            displayFields: [{title: 'Distributor Name', field: 'distributor_name'}],
            valueField: 'distributor_id',
          }}
        />
      )}
    </>
  );
}

export default CreateDistributorOrderPage;
